// Per-route SEO metadata. The <Seo /> component (and the build-time prerender
// pass) reads this map to set title/description/canonical/OG tags per route.
// Canonical host is the apex domain — https://vishwalab.com.

export const SITE_ORIGIN = 'https://vishwalab.com'

export const DEFAULT_META = {
  title: 'Vishwa | The Banking Infrastructure for Autonomous Capital',
  description:
    'Vishwa builds the banking infrastructure for autonomous capital, where control is enforced before execution.',
}

export const ROUTE_META = {
  '/': {
    title: 'Vishwa | The Banking Infrastructure for Autonomous Capital',
    description:
      'AI agents hold, move, and grow capital through execution controls. Every capital movement is controlled before execution and recorded with an ERC-8150 proof. $170M live on mainnet.',
  },
  '/erc': {
    title: 'ERC-8150: zk-Verifiable Agent Transactions | Vishwa',
    description:
      'The ERC-8150 specification, authored by Vishwa: authorization proofs for AI agent transactions that are signed, on-chain, and independently checkable.',
  },
  '/solutions': {
    title: 'Solutions: Verification & Messaging Infrastructure | Vishwa',
    description:
      'Trustless messaging and verification infrastructure on and off Bitcoin L1, plus cross-chain proof-of-asset for institutions.',
  },
  '/custodial': {
    title: 'Custodial Yield Generation | Vishwa',
    description:
      'Custodial yield strategies with verification-first controls: every capital movement is authorized before execution.',
  },
  '/nonCustodial': {
    title: 'Non-Custodial Yield Generation | Vishwa',
    description:
      'Non-custodial yield strategies where assets stay verifiable on-chain and agent actions run inside enforced limits.',
  },
  '/digitalAssets': {
    title: 'Institutional Digital Assets | Vishwa',
    description:
      'Institution-ready digital asset infrastructure: compliance-aware custody integrations and cross-chain proof-of-asset verification.',
  },
  '/privateCredit': {
    title: 'Private Credit | Vishwa',
    description:
      'Private credit infrastructure with cryptographic proof-of-asset verification for lenders and institutions.',
  },
  '/tokenizedRWA': {
    title: 'Tokenized Real-World Assets | Vishwa',
    description:
      'Tokenized RWA infrastructure: verify collateral across chains and route it into lending and yield with enforced controls.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | Vishwa',
    description: 'How Vishwa collects, uses, and protects personal data.',
  },
  '/terms-of-service': {
    title: 'Terms of Service | Vishwa',
    description: 'The terms governing use of Vishwa websites and services.',
  },
  '/cookie-policy': {
    title: 'Cookie Policy | Vishwa',
    description: 'How Vishwa uses cookies and how to manage consent.',
  },
}

export const PRERENDER_ROUTES = Object.keys(ROUTE_META)
